import { BodyM, colorVariants } from '@casavo/base-ui'
import cn from 'classnames'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { flexCenter, gap } from '@/shared-styles/styles.css'

import CasavoLogoSmall from '../Icon/CasavoLogoSmall'
import { Translated } from '../Translated'

type Props = {
  className?: string
  i18nKey: string
  light?: boolean
}

export const ThisIsACasavoClaim: React.FC<Props> = ({ className, i18nKey, light }) => {
  return (
    <div className={cn(flexCenter, gap.s, light && colorVariants.white, className)}>
      <CasavoLogoSmall className={sprinkles({ flexShrink: 0 })} />
      <BodyM color={light ? 'white' : 'greyscale600'}>
        <Translated i18Key={i18nKey} />
      </BodyM>
    </div>
  )
}
